import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { GlobalStyle } from './AppStyle';
import App from './routes/App';
import IntegrationContext from 'context/IntegrationContext';
import { IntegrationVariables } from 'context/IntegrationContext';

import store from 'store';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

ReactDOM.render(
<React.StrictMode>
    <IntegrationContext.Provider value={IntegrationVariables}>
        <GlobalStyle />
        <Provider store={store}>
            <App />
        </Provider>
    </IntegrationContext.Provider>
</React.StrictMode>,
container,
);
